import React from 'react';

import ProjectScope from "./projectScope";
import * as Misc from "./../../misc";

export default (props) => {
  const f = props.feature;
  const scopeFeatures = props.scopeFeatures;

  return (<div className="project-scope-selection-options">
    <div className="project-scope-selection-bullet">{scopeFeatures[f.id]}</div>
    <span>{f.displayName}</span>
    <div className="project-scope-selection-remove-button"
         onClick={e => Misc.ignore(e, () => ProjectScope.removeFeature(props.feature.id))}/>
  </div>);
};





// WEBPACK FOOTER //
// ./src/components/projectScope/individualFeatureItem.js